import React, { useEffect, useMemo, useRef, useState } from 'react';
import { compose } from 'redux';
import { connect, useDispatch } from 'react-redux';
import classNames from 'classnames';
import { useHistory, useLocation } from 'react-router-dom';
import { bool, func, oneOf, object, shape, string, number } from 'prop-types';
import algoliasearch from 'algoliasearch/lite';
import aa from 'search-insights';
import {
  Hits,
  SortBy,
  useStats,
  SearchBox,
  Configure,
  InstantSearch,
  useClearRefinements,
  useHierarchicalMenu,
  Pagination,
} from 'react-instantsearch';

import { useConfiguration } from '../../context/configurationContext';
import { useRouteConfiguration } from '../../context/routeConfigurationContext';
import AlgoliaFilterPanel, { SelectSubCategoryFilter } from './AlgoliaFilterPanel';
import { searchParamsPicker, createSearchResultSchema } from './AlgoliaSearchPage.helpers';
import {
  propTypes,
  ALOGOLIA_SEARCH_ATTRIBUTES,
  ALOGOLIA_SEARCH_COMPONENT,
  algoliaSortOptions,
  SAVED_POST,
  FEED_TAB,
  MARKETPLACE,
  ACTIVITY,
  communityPostAccess,
  REQUEST_GROUP_PREGRESS,
  communityGorupAccess,
  abilityToSell,
  mobileAlgoliaSortOptions,
} from '../../util/types';
import { withViewport } from '../../util/uiHelpers';
import { FormattedMessage, intlShape, useIntl } from '../../util/reactIntl';
import { createResourceLocatorString } from '../../util/routes';
import { parse } from '../../util/urlHelpers';
import {
  checkElephantModalOpen,
  currentUserRole,
  getUserPermissions,
  makeAlgoliaSearchParams,
  setAlgoliaInitailState,
} from '../../util/data';
import {
  Page,
  Modal,
  AlogoliaSearchCard,
  IconCollection,
  Button,
  IconProfileCard,
  IconSpinner,
  LeftSideDesktopSidebar,
  OutsideClickHandler,
} from '../../components';
import { updateProfile } from '../ProfileSettingsPage/ProfileSettingsPage.duck';
import { manageDisableScrolling, isScrollingDisabled } from '../../ducks/ui.duck';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterComponent from '../FooterContainer/FooterContainer';

import css from './AlgoliaSearchPage.module.css';
import FeedTabs from '../CircleCommunityPage/components/FeedTabs/FeedTabs';
import { algoliaEventSearchQuery } from './AlgoliaEvents';
import {
  advancedSearch,
  createSpacePost,
  deleteBookMark,
  fetchBookMarList,
  fetchSpaceList,
  fetchUserActivity,
  setActiveTab,
  toggelRequestSpaceReducer,
  toggleCreatePost,
} from '../CircleCommunityPage/CircleCommunityPage.duck';
import BookmarkModal from '../CircleCommunityPage/components/BookmarkModal/BookmarkModal';
import MyActivityModal from '../CircleCommunityPage/components/MyActivity/MyActivityModal';
import RequestSpaceModal from '../CircleCommunityPage/components/SpaceGroups/RequestSpaceModal';
import { onCreateIntercomTicket, onSingleMailApiCollection } from '../../util/api';
import { toastifyFn } from '../../components/ReactToastify/ReactToastify';
import MobileBottomTabs from '../CircleCommunityPage/components/MobileBottomTabs/MobileBottomTabs';
import { openIntecomOnClickEvents } from '../../components/IntercomComponent/IntercomComponent';
import { setElephantVerificationModal, subscriptionPermissionRequest } from '../../ducks/user.duck';
import CreatePostBar from '../CircleCommunityPage/components/CreatePostBar/CreatePostBar';
import LeftSideTabSidebar from '../../components/LeftSideTabSidebar/LeftSideTabSidebar';
import { getLocationByZipCode } from '../../util/maps';
// import CustomHits from './CustomHits';

const {
  REACT_APP_ALGOLIA_LISTING_INDEX,
  REACT_APP_ALGOLIA_APP_ID,
  REACT_APP_ALGOLIA_SEARCH_API_KEY,
} = process.env;

const indexName = REACT_APP_ALGOLIA_LISTING_INDEX;

const MAX_MOBILE_SCREEN_WIDTH = 768;

export const createAlgoliaSearchClient = (appId, searchApiKey) =>
  appId && searchApiKey
    ? algoliasearch(appId, searchApiKey, {
        _useRequestCache: true,
      })
    : null;

const searchClient = createAlgoliaSearchClient(
  REACT_APP_ALGOLIA_APP_ID,
  REACT_APP_ALGOLIA_SEARCH_API_KEY
);

const Panel = ({ children, header, footer }) => {
  return (
    <div className="ais-Panel">
      {header && <div className="ais-Panel-header">{header}</div>}
      <div className="ais-Panel-body">{children}</div>
      {footer && <div className="ais-Panel-footer">{footer}</div>}
    </div>
  );
};

const CustomStats = props => {
  const { isMobileLayout } = props;
  const useStatsProps = useStats();
  const { nbHits, page, hitsPerPage, processingTimeMS, nbPages } = useStatsProps;

  return (
    <div className={css.noDataFoundWrapper}>
      {processingTimeMS ? (
        <>
          <span className={css.searchResults}>
            {/* Showing {page + 1} - {hitsPerPage} out of  */}

            {isMobileLayout ? (
              <div className={css.hitsList}>{`${nbHits}`} Results</div>
            ) : (
              <>
                {' '}
                <div className={css.hitsList}>
                  {`${
                    nbPages == page + 1 ? nbHits : (nbHits ? hitsPerPage : 0) * (page + 1)
                  } of ${nbHits}`}{' '}
                </div>
              </>
            )}
          </span>
          {/* <div
          className={classNames(
            css.noDataFound
          )}
        >
          {' '}
          {nbHits < 1 ? <FormattedMessage id="AlgoliaSearchPage.noResults" /> : null}
        </div> */}
        </>
      ) : (
        <IconSpinner />
      )}
    </div>
  );
};

const CustomStatsNoResult = props => {
  const useStatsProps = useStats();
  const { nbHits, page, hitsPerPage, processingTimeMS } = useStatsProps;

  return nbHits < 1 && processingTimeMS ? (
    <div className={css.noResultText}>
      <FormattedMessage id="AlgoliaSearchPage.noResults" />
    </div>
  ) : (
    <></>
  );
};

export const AlgoliaSearchPageComponent = props => {
  const {
    intl,
    config,
    routes,
    history,
    location,
    viewport,
    listings,
    currentUser,
    searchParams,
    updateInProgress,
    scrollingDisabled,
    routeConfiguration,
    onUpdateProfile,
    activeTab,
    onSetActiveTab,
    requestBookmarksList,
    bookmarksListData,
    onDeleteBookMark,
    onManageDisableScrolling,
    onFetchUserActivity,
    fetchUserActivityRequest,
    fetchUserActivityData,
    fetchUserActivityError,
    currentCommunityMember,
    onRequestGroupClick,
    isRequestSpace,
    spaceListData,
    requestNewSpace,
    accessToken,
    isLoggedInAs,
    isCreatePost,
    requestDirectUpload,
    advancedSearchData,
    onSubscriptionPermissionRequest,
    onAdvancedSearch,
    params,
    onSetElephantVerificationModal,
    onCreateSpacePost,
    onToggleCreatePost,
  } = props;

  const userNotFound = !accessToken?.success && !!accessToken?.message;

  const { roles, id: community_member_id } = currentCommunityMember || {};

  const searchQuery = useMemo(() => parse(location?.search || '') || {}, [location?.search]);

  const isMobileLayout = viewport?.width < MAX_MOBILE_SCREEN_WIDTH;
  const [loading, setLoading] = useState(false);
  const [isMobileFilter, setIsMobileFilter] = useState(false);
  const [showMoreFilters, setShowMoreFilters] = useState(false);
  const [isBookmarkListRequested, setIsBookmarkListRequested] = useState(false);
  const clearedFilterParamsRef = useRef(new Set());
  const dispatch = useDispatch();

  // state for algolia
  const [algoliaState, setAlgoliaState] = useState(searchQuery);
  const isFilterApplied = typeof algoliaState == 'object' && Object.keys(algoliaState).length;

  const [isNearMe, setIsNearMe] = useState('');

  useEffect(() => {
    setAlgoliaState(searchQuery);
  }, [searchQuery]);

  // Calculate dynamic count of applied filters (exclude non-filter keys)
  const appliedFiltersCount = useMemo(() => {
    const excluded = new Set(['query', 'page', 'sort', 'condition', 'subCategoryName']);
    if (!algoliaState || typeof algoliaState !== 'object') return 0;
    return Object.entries(algoliaState).reduce((count, [key, value]) => {
      if (excluded.has(key)) return count;
      if (value == null) return count;
      const str = String(value).trim();
      return str ? count + 1 : count;
    }, 0);
  }, [algoliaState]);

  const handleTabClick = item => {
    const { tab, pageName } = item;
    onSetActiveTab(tab);
    if (tab == SAVED_POST) {
      setIsBookmarkListRequested(true);
      dispatch(fetchBookMarList({}));
    }
    if (tab == ACTIVITY) {
      onFetchUserActivity({ community_member_id, fetchTab: 'posts' });
    }
    return (
      pageName && history.push(createResourceLocatorString(pageName, routeConfiguration, {}, {}))
    );
  };

  useEffect(() => {
    if (currentUser && currentUser.id) {
      dispatch(fetchSpaceList());
    }
  }, [currentUser]);

  const handlePostCreation = async (apiParams, spaceId, postId) => {
    const response = await onCreateSpacePost(apiParams, spaceId, postId);
    if (response?.id) {
      return history.push(
        createResourceLocatorString('PostViewPage', routeConfiguration, {
          spaceId,
          slug: response?.slug,
          postId: response?.id,
        })
      );
    }
  };

  const userSubscriptionRole = currentUserRole(currentUser);

  const isOpenElephantModal = checkElephantModalOpen(currentUser);

  // <<<<<<<<<<<<< all access checked by this fn >>>>>>>>>>>>>>>>>>>>>
  // communityPostAccess >> user can create post or not
  const checkCreatePostAuth = getUserPermissions(userSubscriptionRole, communityPostAccess);

  const handleIconClick = content => {
    const { tab, pageName, params } = content;
    if (tab === 'ADD_MENU') {
      if (isOpenElephantModal && !isCreatePost) {
        onSetElephantVerificationModal(true);
        return;
      }
      if (!checkCreatePostAuth) {
        dispatch(subscriptionPermissionRequest(true));
        return;
      }
      onToggleCreatePost(true);

      return;
    } else if (tab == 'SUPPORT') {
      openIntecomOnClickEvents();
      return;
    } else {
      return (
        pageName &&
        history.push(createResourceLocatorString(pageName, routeConfiguration, params, {}))
      );
    }
  };

  const mobileBottomTabsComponent = currentUser ? (
    <MobileBottomTabs
      handleIconClick={handleIconClick}
      currentUser={currentUser}
      selectedTab={'MARKETPLACE'}
    />
  ) : null;
  const Hit = props => {
    const { hit } = props;

    return (
      <AlogoliaSearchCard
        hit={hit}
        currentUser={currentUser}
        updateInProgress={updateInProgress}
        onUpdateProfile={onUpdateProfile}
        algoliaState={algoliaState}
        currentPage={'AlgoliaSearchPage'}
        isMobileLayout={isMobileLayout}
      />
    );
  };
  const { listingFields: listingFieldsConfig } = config?.listing || {};
  const { defaultFilters: defaultFiltersConfig, sortConfig } = config?.search || {};

  // Page transition might initially use values from previous search
  // urlQueryParams doesn't contain page specific url params
  // like mapSearch, page or origin (origin depends on config.maps.search.sortSearchByDistance)
  const { searchParamsInURL } = searchParamsPicker(
    location.search,
    searchParams,
    listingFieldsConfig,
    defaultFiltersConfig,
    sortConfig,
    false
  );

  const { title, description, schema } = createSearchResultSchema(
    listings,
    searchParamsInURL || {},
    intl,
    routeConfiguration,
    config
  );

  // <<<<<<<<<<<<< all access checked by this fn >>>>>>>>>>>>>>>>>>>>>
  // communityPostAccess >> user can create post or not
  const checkCreateGroupAuth = getUserPermissions(userSubscriptionRole, communityGorupAccess);

  const userAbilityToSell = getUserPermissions(userSubscriptionRole, abilityToSell);

  const sortBy = (
    <div className={css.shortWrapper}>
      <SortBy items={isMobileLayout ? mobileAlgoliaSortOptions : algoliaSortOptions} />
    </div>
  );

  const ClearFilters = () => {
    const { refine, canRefine } = useClearRefinements();
    return (
      <div className={css.clearFilter}>
        <button
          className={`ais-ClearRefinements-button ${
            !canRefine ? 'ais-ClearRefinements-button--disabled' : ''
          }`}
          // disabled={!canRefine}
          type="button"
          onClick={e => {
            if (isMobileLayout) {
              // Preserve selected condition on mobile, but clear category filters.
              const currentParams = new URLSearchParams(location.search);
              const preservedParams = {};
              if (currentParams.has('condition')) {
                preservedParams.condition = currentParams.get('condition');
              }

              // Clear Algolia refinements and then set only preserved params
              refine(e);
              setAlgoliaState(preservedParams);
              history.push(createResourceLocatorString('SearchPage', routes, {}, preservedParams));
              return null;
            } else {
              refine(e);
              setAlgoliaState({});
              history.push(createResourceLocatorString('SearchPage', routes, {}, {}));
              return null;
            }
          }}
        >
          <div className="clear-filters">
            {isMobileLayout ? (
              <FormattedMessage id="AlgoliaSearchPage.clearFilters.mobile" />
            ) : (
              <FormattedMessage id="AlgoliaSearchPage.clearFilters.desktop" />
            )}
          </div>
        </button>
      </div>
    );
  };

  const {
    range_input,
    menuSelect,
    customRefinementList,
    hierarchicalList,
    refinement_list,
  } = ALOGOLIA_SEARCH_COMPONENT;

  const allfilters = [
    // {
    //   title: 'Categories',
    //   component: hierarchicalList,
    //   attribute: ALOGOLIA_SEARCH_ATTRIBUTES['hierarchicalCategories'],
    //   searchablePlaceholder: '',
    //   moreFilter: false,
    //   isOpen: true,
    // },
    {
      title: 'Price',
      component: range_input,
      attribute: ALOGOLIA_SEARCH_ATTRIBUTES['price'],
      searchablePlaceholder: 'Price',
      moreFilter: false,
      isOpen: true,
    },
    {
      title: 'Brand',
      component: customRefinementList,
      attribute: ALOGOLIA_SEARCH_ATTRIBUTES['brand'],
      searchablePlaceholder: 'Brand',
      showMore: false,
      moreFilter: false,
    },
    {
      title: 'Color',
      component: customRefinementList,
      attribute: ALOGOLIA_SEARCH_ATTRIBUTES['color'],
      searchablePlaceholder: 'Colour',
      showMore: false,
      moreFilter: false,
    },
    {
      title: 'Size',
      component: customRefinementList,
      attribute: ALOGOLIA_SEARCH_ATTRIBUTES['size'],
      searchablePlaceholder: 'size',
      showMore: false,
      moreFilter: false,
    },
    {
      title: 'Type',
      component: customRefinementList,
      attribute: ALOGOLIA_SEARCH_ATTRIBUTES['type'],
      searchablePlaceholder: 'type',
      showMore: false,
      moreFilter: false,
    },
  ];

  if (!isMobileLayout) {
    allfilters.unshift({
      title: 'Categories',
      component: hierarchicalList,
      attribute: ALOGOLIA_SEARCH_ATTRIBUTES['hierarchicalCategories'],
      searchablePlaceholder: '',
      moreFilter: false,
      isOpen: true,
    });
  }
  if (!isMobileLayout) {
    allfilters.push({
      title: 'Condition',
      component: customRefinementList,
      attribute: ALOGOLIA_SEARCH_ATTRIBUTES['condition'],
      searchablePlaceholder: 'condition',
      showMore: false,
      moreFilter: false,
    });
  }

  // Mobile specific filters
  if (isMobileLayout) {
    allfilters.push({
      title: 'Pickup & Delivery',
      component: customRefinementList,
      attribute: ALOGOLIA_SEARCH_ATTRIBUTES['pickShippingOptions'],
      searchablePlaceholder: 'Pickup & Delivery',
      showMore: false,
      moreFilter: false,
    });
    allfilters.push({
      title: 'location',
      component: customRefinementList,
      attribute: ALOGOLIA_SEARCH_ATTRIBUTES['pickShippingDetailsCity'],
      searchablePlaceholder: 'location',
      showMore: false,
      moreFilter: false,
      isNearMe: isNearMe,
    });
  }

  const filterPanel = (
    <AlgoliaFilterPanel
      Panel={Panel}
      currentUser={currentUser}
      algoliaState={algoliaState}
      isMobileLayout={isMobileLayout}
      showMoreFilters={showMoreFilters}
      setShowMoreFilters={setShowMoreFilters}
      filterPanel={allfilters}
      currentPage={'AlgoliaSearchPage'}
      setAlgoliaState={setAlgoliaState}
      history={history}
      location={location}
      onClearFilter={param => {
        if (param) {
          clearedFilterParamsRef.current.add(param);
        }
      }}
    />
  );

  // Initialize mobile condition filter from URL
  const getConditionFromUrl = () => {
    const urlParams = new URLSearchParams(location.search);
    const condition = urlParams.get('condition');
    return condition && ['New', 'Used'].includes(condition) ? condition : 'All';
  };

  const [mobileConditionFilter, setMobileConditionFilter] = useState(getConditionFromUrl());

  // Sync mobile condition filter with URL changes (e.g., when navigating back/forward)
  useEffect(() => {
    const conditionFromUrl = getConditionFromUrl();
    if (conditionFromUrl !== mobileConditionFilter) {
      setMobileConditionFilter(conditionFromUrl);
    }
  }, [location.search]);

  // Mobile condition tabs component
  const MobileConditionTabs = () => {
    const handleTabClick = value => {
      setMobileConditionFilter(value);

      // Update URL with condition parameter
      const currentParams = new URLSearchParams(location.search);
      if (value === 'All') {
        currentParams.delete('condition');
      } else {
        currentParams.set('condition', value);
      }

      // Update algoliaState to include the condition
      const updatedState = { ...algoliaState };
      if (value === 'All') {
        delete updatedState.condition;
      } else {
        updatedState.condition = value;
      }
      setAlgoliaState(updatedState);

      const newUrl = `${location.pathname}?${currentParams.toString()}`;
      history.push(newUrl);
    };

    return (
      <div className={classNames(css.mobileFeatures, css.fullWidth)}>
        <div className={css.tabSelectWrapper}>
          <div
            className={classNames(css.tabSelect, {
              [css.selected]: mobileConditionFilter === 'All',
            })}
            onClick={() => handleTabClick('All')}
          >
            <FormattedMessage id="AlgoliaSearchPage.condition.all" />
          </div>
          <div
            className={classNames(css.tabSelect, {
              [css.selected]: mobileConditionFilter === 'New',
            })}
            onClick={() => handleTabClick('New')}
          >
            <FormattedMessage id="AlgoliaSearchPage.condition.new" />
          </div>
          <div
            className={classNames(css.tabSelect, {
              [css.selected]: mobileConditionFilter === 'Used',
            })}
            onClick={() => handleTabClick('Used')}
          >
            <FormattedMessage id="AlgoliaSearchPage.condition.used" />
          </div>
        </div>
      </div>
    );
  };

  // Mobile category dropdown component
  const MobileCategoryDropdown = () => {
    return (
      <div className={classNames(css.fullWidth, css.mobileFeatures)}>
        <div className={css.customSelect}>
          <SelectSubCategoryFilter
            label="Category"
            attribute="publicData.subCategoryName"
            algoliaState={algoliaState}
            currentUser={currentUser}
            setAlgoliaState={setAlgoliaState}
            history={history}
            location={location}
            indexName={process.env.REACT_APP_ALGOLIA_LISTING_INDEX}
            isMobileLayout={isMobileLayout}
          />
        </div>
      </div>
    );
  };

  const searchFilters = (
    <div className={css.searchfilter}>
      {isMobileLayout ? <CustomStats isMobileLayout={isMobileLayout} /> : null}
      <div className={css.rightFilters}>
        <div
          className={classNames(css.aisInstantSearch, currentUser ? '' : css.notLoginUserSearch)}
        >
          <div className={classNames(css.filterWrapper, css.filterDesktop)}>
            <LeftSideTabSidebar />
            {/* <FeedTabs
            handleTabClick={handleTabClick}
            activeTab={activeTab}
            onRequestGroupClick={onRequestGroupClick}
            checkCreateGroupAuth={checkCreateGroupAuth}
            handleCreateListingClick={handleCreateListingClick}
            userNotFound={userNotFound}
            isLoggedInAs={isLoggedInAs}
            userAbilityToSell={userAbilityToSell}
          /> */}
            {filterPanel}
          </div>
        </div>

        {/* {isMobileLayout ? null :
        <div className={css.clearFilter}>
          <button
            className={`ais-ClearRefinements-button`}
            type="button"
            onClick={(e) => {
              setShowMoreFilters(true)
            }}
          >
            <div className="clear-filters">
              + More Filters
            </div>
          </button>
        </div>
      } */}
        {isFilterApplied ? (
          <div>
            <ClearFilters />
          </div>
        ) : null}
        {/* {isMobileLayout ? null : <div>{sortBy}</div>} */}
      </div>
    </div>
  );

  const { businessCollection = false, theEdit = false } =
    typeof algoliaState == 'object' ? algoliaState : {};

  const makeSearchRoute = uiState => {
    const searchParams = makeAlgoliaSearchParams(indexName, uiState, true);

    // Preserve existing URL parameters that aren't handled by Algolia
    const currentParams = new URLSearchParams(location.search);
    const preservedParams = {};

    // List of parameters to preserve from current URL
    const paramsToPreserve = ['condition']; // Add other custom params here if needed

    paramsToPreserve.forEach(param => {
      if (currentParams.has(param) && !clearedFilterParamsRef.current.has(param)) {
        preservedParams[param] = currentParams.get(param);
      }
    });

    // On mobile, also preserve the current mobile condition filter state
    if (
      isMobileLayout &&
      mobileConditionFilter &&
      mobileConditionFilter !== 'All' &&
      !clearedFilterParamsRef.current.has('condition')
    ) {
      preservedParams.condition = mobileConditionFilter;
    }
    clearedFilterParamsRef.current.clear();

    // Merge preserved params with Algolia search params (preserved params take priority)
    const finalSearchParams = { ...searchParams, ...preservedParams };

    typeof window != 'undefined' &&
      window.sessionStorage.setItem('searchParams', JSON.stringify(finalSearchParams));
    setAlgoliaState(finalSearchParams);
    return history.push(createResourceLocatorString('SearchPage', routes, {}, finalSearchParams));
  };

  const onStateChange = props => {
    const { uiState, setUiState } = props;
    setUiState(uiState);
    makeSearchRoute(uiState);
  };

  useEffect(() => {
    onSetActiveTab(MARKETPLACE);
    const initializeAlgolia = () => {
      try {
        // Extract user ID from the currentUser object
        const userId = currentUser?.id?.uuid;

        // Proceed only if userId exists
        if (userId) {
          // Get the Algolia credentials from environment variables
          const ALGOLIA_APP_ID = process.env.REACT_APP_ALGOLIA_APP_ID;
          const ALGOLIA_SEARCH_API_KEY = process.env.REACT_APP_ALGOLIA_SEARCH_API_KEY;

          // Validate environment variables
          if (!ALGOLIA_APP_ID || !ALGOLIA_SEARCH_API_KEY) {
            throw new Error('Algolia App ID or API Key is missing from environment variables.');
          }

          // Initialize Algolia Insights
          aa('init', {
            appId: ALGOLIA_APP_ID,
            apiKey: ALGOLIA_SEARCH_API_KEY,
            useCookie: true, // Use cookies to persist the user session
          });

          // Set the user token in Algolia Insights
          aa('setAuthenticatedUserToken', userId); // Authenticate user
          aa('setUserToken', userId); // Optionally, you can use this for additional tracking
        } else {
          console.warn('User ID is not available, skipping Algolia Insights initialization.');
        }
      } catch (error) {
        console.error('Error initializing Algolia Insights:', error);
      }
    };

    const initializeNearme = async () => {
      try {
        const userId = currentUser?.id?.uuid;
        const { zipCode, countryCode = '' } = currentUser?.attributes?.profile?.publicData || {};
        // Add Near me in location
        if (userId && zipCode) {
          const location = await getLocationByZipCode(
            zipCode,
            ['CA', 'US'].includes(countryCode) ? '' : countryCode
          );
          const { state, countryCode: nearCountryCode, city } = location || {};
          console.log(
            `${city || state},${nearCountryCode}`,
            '&&& &&& => `${state},${nearCountryCode}`'
          );
          if ((state || city) && nearCountryCode) {
            setIsNearMe(`${city || state},${nearCountryCode}`);
          }
        } else {
          console.warn('Add Near me in location skipped');
        }
      } catch (error) {}
    };

    // Call the initialization function
    initializeAlgolia();
    initializeNearme();
  }, [currentUser]); // Only re-run when `currentUser` changes

  const BookmarkComponent = isBookmarkListRequested ? (
    <BookmarkModal
      requestBookmarksList={requestBookmarksList}
      isBookmarkListRequested={isBookmarkListRequested}
      setIsBookmarkListRequested={setIsBookmarkListRequested}
      bookmarksListData={bookmarksListData}
      onDeleteBookMark={onDeleteBookMark}
      history={history}
      routeConfiguration={routeConfiguration}
      onManageDisableScrolling={onManageDisableScrolling}
      onSetActiveTab={() => onSetActiveTab(MARKETPLACE)}
    />
  ) : null;

  const onRequestSpace = async values => {
    try {
      setLoading(REQUEST_GROUP_PREGRESS);
      const sendMail = await onCreateIntercomTicket(values);
      // onSingleMailApiCollection(values);

      toastifyFn('success', 'Request sent successfully');
      return sendMail;
    } catch (e) {
      toastifyFn('error', 'opps something went wrong');
      console.error(e, '&&& &&& => e');
      return e;
    } finally {
      setLoading(false);
      onRequestGroupClick(false);
    }
  };
  return (
    <Page
      scrollingDisabled={scrollingDisabled}
      description={description}
      title={title}
      schema={schema}
      className={css.mainWrapper}
    >
      <TopbarContainer
        currentSearchParams={{ ...algoliaState, keywords: algoliaState.query || '' }}
        currentPage={'SearchPage'}
      />

      <div className={css.container}>
        <div className={classNames(css.searchWrapper)}>
          {searchClient && indexName ? (
            <InstantSearch
              key={location?.search || 'empty-search'}
              searchClient={searchClient}
              indexName={indexName}
              // routing={true}
              initialUiState={setAlgoliaInitailState(indexName, searchQuery, false, true)}
              insights={true}
              onStateChange={onStateChange}
            >
              <Configure
                filters={(() => {
                  let baseFilters = `(state:"published") AND (quantity > 0)`; // OR state:"closed"

                  // Add condition filter if present
                  if (mobileConditionFilter && mobileConditionFilter !== 'All') {
                    baseFilters += ` AND publicData.condition:"${mobileConditionFilter}"`;
                  }

                  // Add subcategory filter if present in URL
                  const urlParams = new URLSearchParams(location.search);
                  const subCategoryName = urlParams.get('subCategoryName');
                  if (subCategoryName) {
                    baseFilters += ` AND publicData.subCategoryName:"${subCategoryName}"`;
                  }

                  // Add hierarchicalCategories filter if present in URL (for mobile navigation)
                  const hierarchicalCategories = urlParams.get('hierarchicalCategories');
                  if (hierarchicalCategories) {
                    // Split by comma to handle multi-level categories (e.g., "For The Rider,Boots")
                    const categoryLevels = hierarchicalCategories.split(',');
                    // Apply filter on the deepest level category
                    const deepestCategory = categoryLevels[categoryLevels.length - 1];
                    const levelIndex = categoryLevels.length - 1;
                    baseFilters += ` AND hierarchicalCategories.lvl${levelIndex}:"${categoryLevels.join(
                      ' > '
                    )}"`;
                  }

                  return baseFilters;
                })()}
                ruleContexts={[]}
                hitsPerPage={12}
              />
              <div className={css.algoliaContainerWrapper}>
                <div className={isMobileLayout ? null : css.leftsideNav}>
                  {isMobileLayout ? null : searchFilters}
                </div>
                <div className={classNames(css.Resultcontainer, css.rightSideContainer)}>
                  <section className={css.conatinerResult}>
                    <header className={css.headerRightSection}>
                      <div className={css.desktopFeatures}>
                        <div className={css.filterResult}>
                          <CustomStats isMobileLayout={isMobileLayout} />
                          {isMobileLayout ? (
                            <div className={css.mobileFilters}>
                              <Button
                                onClick={e => {
                                  e.preventDefault();
                                  setIsMobileFilter(true);
                                }}
                                className={css.mobileButton}
                              >
                                Filters
                              </Button>
                              {/* <div className={css.mobileButton}>
                              {sortBy}
                            </div> */}
                            </div>
                          ) : null}
                          <Modal
                            isOpen={isMobileFilter}
                            onClose={() => setIsMobileFilter(false)}
                            onManageDisableScrolling={onManageDisableScrolling}
                            modalTitle="Filters"
                            id="AlgoliasSearchPage.filterModal"
                            className={css.filterModal}
                          >
                            <div className={classNames(css.filterWrapper)}> {searchFilters}</div>
                          </Modal>
                        </div>
                      </div>

                      <MobileConditionTabs />

                      <MobileCategoryDropdown />

                      <div className={classNames(css.mobileFeatures, css.fullWidth)}>
                        <div className={css.filterResult}>
                          {isMobileLayout ? (
                            <div className={css.mobileFilters}>
                              <Button
                                onClick={e => {
                                  e.preventDefault();
                                  setIsMobileFilter(true);
                                }}
                                className={css.mobileButton}
                              >
                                {' '}
                                <IconCollection name={'filterSetting'} />
                                <span>Filters ({appliedFiltersCount})</span>
                              </Button>

                              <div
                                className={classNames(
                                  css.mobileFeatures,
                                  css.sortbyContainer,
                                  css.mobileButton
                                )}
                              >
                                {sortBy}
                              </div>

                              {/* <div className={css.mobileButton}>
                              {sortBy}
                            </div> */}
                            </div>
                          ) : null}
                          <OutsideClickHandler
                            className={css.outSideClick}
                            onOutsideClick={() => setIsMobileFilter(false)}
                          >
                            <Modal
                              isOpen={isMobileFilter}
                              onClose={() => setIsMobileFilter(false)}
                              onManageDisableScrolling={() => {}}
                              modalTitle="Filters"
                              id="AlgoliasSearchPage.filterModal"
                              className={css.filterModal}
                            >
                              <div className={classNames(css.filterWrapper)}> {searchFilters}</div>
                              <div className={classNames(css.mobileFeatures, css.fullWidth)}>
                                <Button
                                  onClick={() => setIsMobileFilter(false)}
                                  className={css.mobileButton}
                                >
                                  <FormattedMessage
                                    id="AlgoliaSearchPage.applyFilters.mobile"
                                    values={{ count: appliedFiltersCount }}
                                  />
                                </Button>
                              </div>
                            </Modal>
                          </OutsideClickHandler>
                          {!isMobileLayout && <CustomStats isMobileLayout={isMobileLayout} />}
                        </div>
                      </div>

                      {isMobileLayout && <CustomStats isMobileLayout={isMobileLayout} />}

                      <div className={css.searchSection}>
                        <div className={css.searchBox}>
                          <SearchBox
                            autoFocus
                            placeholder="Search by keyword"
                            searchAsYouType={true}
                            // onBlur={() => {
                            //   const query = algoliaState?.query;
                            //   console.log(query, "query");
                            //   if (query && query.trim()) {
                            //     algoliaEventSearchQuery(query,currentUser);
                            //   }
                            // }}
                          />
                        </div>
                        {/* <HitsPerPage
                        className="container-option"
                        items={[{
                          value: 16,
                          default: true,
                        }]}
                      /> */}

                        <div className={css.desktopFeatures}>{sortBy}</div>
                      </div>
                    </header>
                    <header className="container-header container-options header-mobile">
                      <div onClick={() => setIsMobileFilter(!isMobileFilter)}>
                        <IconCollection icon="filterIcon" />
                      </div>
                    </header>
                  </section>
                  <div>
                    <CustomStatsNoResult />
                  </div>
                  <div className={css.grid}>
                    <Hits hitComponent={Hit} />
                    {/* <CustomHits /> */}
                    {/* <footer className="container-footer"> */}

                    {/* </footer> */}
                    <div className={css.paginationLink}>
                      <Pagination />
                    </div>
                  </div>
                </div>
              </div>
            </InstantSearch>
          ) : (
            <div className={css.noResultText}>
              <FormattedMessage id="AlgoliaSearchPage.noResults" />
            </div>
          )}
        </div>
        {BookmarkComponent}
        <MyActivityModal
          isMyActivity={activeTab == ACTIVITY}
          onManageDisableScrolling={onManageDisableScrolling}
          onSetActiveTab={() => onSetActiveTab(MARKETPLACE)}
          onFetchUserActivity={onFetchUserActivity}
          fetchUserActivityRequest={fetchUserActivityRequest}
          fetchUserActivityData={fetchUserActivityData}
          fetchUserActivityError={fetchUserActivityError}
          routeConfiguration={routeConfiguration}
          history={history}
          currentCommunityMember={currentCommunityMember}
        />
        <RequestSpaceModal
          isRequestSpace={isRequestSpace}
          onRequestGroupClick={() => onRequestGroupClick(false)}
          spaceListData={spaceListData}
          requestNewSpace={requestNewSpace}
          currentUser={currentUser}
          onRequestSpace={onRequestSpace}
          onManageDisableScrolling={onManageDisableScrolling}
          loading={loading}
        />
      </div>
      {currentUser && currentUser?.id ? mobileBottomTabsComponent : null}
      {isCreatePost ? (
        <div>
          <CreatePostBar
            requestDirectUpload={requestDirectUpload}
            currentCommunityMember={currentCommunityMember}
            spaceListData={spaceListData}
            onCreateSpacePost={handlePostCreation}
            isCreatePost={isCreatePost}
            onToggleCreatePost={value => {
              if (isOpenElephantModal && !isCreatePost) {
                onSetElephantVerificationModal(true);
                return;
              }

              checkCreatePostAuth
                ? onToggleCreatePost(value)
                : onSubscriptionPermissionRequest(true);
            }}
            onAdvancedSearch={onAdvancedSearch}
            advancedSearchData={advancedSearchData}
            params={params}
            currentUser={currentUser}
          />
        </div>
      ) : null}

      {/* <FooterComponent /> */}
    </Page>
  );
};

AlgoliaSearchPageComponent.defaultProps = {
  listings: [],
  mapListings: [],
  pagination: null,
  searchListingsError: null,
  searchParams: {},
  tab: 'listings',
  // filterConfig: config.custom.filters,
  // sortConfig: config.custom.sortConfig,
  activeListingId: null,
  initialSearchFormValues: {},
};

AlgoliaSearchPageComponent.propTypes = {
  onManageDisableScrolling: func.isRequired,
  scrollingDisabled: bool.isRequired,
  searchParams: object,
  tab: oneOf(['filters', 'listings', 'map']).isRequired,
  filterConfig: propTypes.filterConfig,
  sortConfig: propTypes.sortConfig,
  initialSearchFormValues: object,

  // from withRouter
  history: shape({
    push: func.isRequired,
  }).isRequired,
  location: shape({
    search: string.isRequired,
  }).isRequired,

  // form withViewport
  viewport: shape({
    width: number.isRequired,
    height: number.isRequired,
  }).isRequired,

  // from injectIntl
  intl: intlShape.isRequired,
};

const EnhancedAlgoliaSearchPage = props => {
  const config = useConfiguration();
  const routeConfiguration = useRouteConfiguration();
  const intl = useIntl();
  const history = useHistory();
  const location = useLocation();
  const routes = useRouteConfiguration();

  return (
    <AlgoliaSearchPageComponent
      config={config}
      routeConfiguration={routeConfiguration}
      intl={intl}
      history={history}
      location={location}
      routes={routes}
      {...props}
    />
  );
};

const mapStateToProps = state => {
  const { isLoggedInAs } = state.auth;
  const {
    currentUser,
    currentUserListing,
    currentUserListingFetched,
    categories,
    subCategories,
    subChildCategories,
  } = state.user;
  const { updateInProgress } = state.ProfileSettingsPage;
  const {
    activeTab,
    requestBookmarksList,
    bookmarksListData,
    requestPostCommentList,
    fetchUserActivityRequest,
    fetchUserActivityData,
    fetchUserActivityError,
    currentCommunityMember,
    isRequestSpace,
    spaceListData,
    requestNewSpace,
    accessToken,
    isCreatePost,
    requestDirectUpload,
    advancedSearchData,
  } = state.CircleCommunityPage;

  return {
    scrollingDisabled: isScrollingDisabled(state),
    currentUser,
    currentUserListing,
    currentUserListingFetched,
    categories,
    subCategories,
    subChildCategories,
    updateInProgress,
    activeTab,
    requestBookmarksList,
    bookmarksListData,
    requestPostCommentList,
    fetchUserActivityRequest,
    fetchUserActivityData,
    fetchUserActivityError,
    currentCommunityMember,
    isRequestSpace,
    spaceListData,
    requestNewSpace,
    accessToken,
    isLoggedInAs,
    isCreatePost,
    requestDirectUpload,
    advancedSearchData,
  };
};

const mapDispatchToProps = dispatch => ({
  onManageDisableScrolling: (componentId, disableScrolling) =>
    dispatch(manageDisableScrolling(componentId, disableScrolling)),
  onUpdateProfile: data => dispatch(updateProfile(data)),
  onSetActiveTab: tab => dispatch(setActiveTab(tab)),
  onDeleteBookMark: apiParams => dispatch(deleteBookMark(apiParams)),
  onFetchUserActivity: params => dispatch(fetchUserActivity(params)),
  onRequestGroupClick: value => dispatch(toggelRequestSpaceReducer(value)),
  onToggleCreatePost: () => dispatch(toggleCreatePost()),
  onCreateSpacePost: (apiParams, spaceId) => dispatch(createSpacePost(apiParams, spaceId)),
  onSubscriptionPermissionRequest: type => dispatch(subscriptionPermissionRequest(type)),
  onAdvancedSearch: params => dispatch(advancedSearch(params)),
  onSetElephantVerificationModal: params => dispatch(setElephantVerificationModal(params)),
});

const AlgoliaSearchPage = compose(
  withViewport,
  connect(mapStateToProps, mapDispatchToProps)
)(EnhancedAlgoliaSearchPage);

export default AlgoliaSearchPage;
// Searchable attributes
// title(unordered)
// description(unordered)
// publicData.categoryName(unordered)
// publicData.subCategoryName(unordered)
// publicData.TypeName(unordered)
// publicData.BrandName(unordered)
// publicData.MaterialName(unordered)
// publicData.condition(unordered)

// hierarchicalCategories.lvl0
// hierarchicalCategories.lvl1
// hierarchicalCategories.lvl2
// price
// publicData.brandName
// publicData.categoryName
// publicData.colorName
// publicData.condition
// publicData.sizeName
// publicData.subCategoryName
// publicData.subSubCategoryName
// publicData.typeName
// state
